import apiClient from '../apiClient';
import { POST_MASTER_REFERENCE_URL } from '../apiUrl';

const postMasterDataReferenceApi = (params, data) => {
  return apiClient.post(POST_MASTER_REFERENCE_URL(params), data);
};

export default postMasterDataReferenceApi;
